import { AutoBonusCarTypeResponse } from "../../../domain/models/integration/auto-bonus-car-types.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isCarType = (value: unknown): value is AutoBonusCarTypeResponse =>
  isRecord(value) &&
  typeof value["rankId"] === "number" &&
  Number.isFinite(value["rankId"]) &&
  typeof value["name"] === "string";

export function isAutoBonusCarTypesResponse(
  value: unknown,
): value is readonly AutoBonusCarTypeResponse[] {
  return Array.isArray(value) && value.every(isCarType);
}
